import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  Link,
} from '../../components'
import Styles from './TargetDateSeriesIssueLink.css'

@CSSModules(Styles, {allowMultiple:true})
export default class TargetDateSeriesIssueLink extends Component {
  static propTypes = {
    // three letters, fff/dff/gef/gff/pff/wff/tff
    iyvCode: PropTypes.string.isRequired,
  }
  constructor(props) {
    super(props)

    const { iyvCode } = props

    this.state = this.getIssueLinkState(iyvCode)
  }

  componentWillReceiveProps(props){
    this.setState(this.getIssueLinkState(props.iyvCode))
  }

  getIssueLinkState(iyvCode){
    let issueUrl = null
    let issueTagline = null
    switch (iyvCode) {
      case 'fff':
        issueUrl = config.routes.issueFossilFuels
        issueTagline = 'Learn how asset managers fuel climate destruction'
        break

      case 'dff':
        issueUrl = config.routes.issueDeforestation
        issueTagline = 'Learn how asset managers fund deforestation'
        break

      case 'ffb':
        issueUrl = config.routes.issueFossilFuelFinanceInsurance
        issueTagline = 'Learn how banks financially support fossil fuels'
        break

      case 'ffi':
        issueUrl = config.routes.issueFossilFuelFinanceInsurance
        issueTagline = 'Learn how insurers financially support fossil fuels'
        break

      case 'gef':
        issueUrl = config.routes.issueGenderEquality
        issueTagline = 'Learn how asset managers invest in gender inequality'
        break

      case 'gff':
        issueUrl = config.routes.issueCivilianFirearms
        issueTagline = 'Learn how asset managers fund gun violence'
        break

      case 'pff':
        issueUrl = config.routes.issuePrisonIndustrialComplex
        issueTagline = 'Learn how asset managers fund the prison industrial complex'
        break

      case 'wff':
        issueUrl = config.routes.issueArmsManufacturers
        issueTagline = 'Learn how asset managers fund arms manufacturers'
        break

      case 'tff':
        issueUrl = config.routes.issueTobacco
        issueTagline = 'Learn how asset managers fund tobacco'
        break
    }

    return {
      issueUrl,
      issueTagline
    }
  }

  render() {
    const { issueUrl, issueTagline } = this.state
    if (!issueUrl || !issueTagline) { return null }

    return (
      <div styleName='companies-methodology-link'>
        <span>The issues</span>
        <div>
          <Link
            to={issueUrl}
            title={issueTagline}
            xstrong
          >
            {issueTagline}
          </Link>
        </div>
      </div>
    )
  }
}